import { motion } from 'framer-motion'
import { useT } from '../../i18n/LocaleContext'
import CalEmbed from '../booking/CalEmbed'
import type { DevisAnswers } from './types'

export default function StepBooking({
  answers,
  booked,
  onBooked,
  active,
}: {
  answers: DevisAnswers
  booked: boolean
  onBooked: () => void
  /** False while the contact page is showing its other tab — see CalEmbed. */
  active: boolean
}) {
  const { t } = useT()

  if (booked) {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        className="py-8 text-center"
      >
        <div className="relative mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-accent-600 to-accent-700 text-white shadow-[0_24px_60px_-18px_rgba(59,93,255,0.7)]">
          <motion.span
            aria-hidden
            animate={{ scale: [1, 1.5, 1], opacity: [0.5, 0, 0.5] }}
            transition={{ duration: 2.4, repeat: Infinity, ease: 'easeInOut' }}
            className="absolute inset-0 rounded-2xl border border-accent-400"
          />
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
            <path d="M5 12l5 5L20 7" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <h3 className="mt-6 text-2xl font-semibold tracking-tight text-ink-950">{t('devisWizard.booking.bookedTitle')}</h3>
        <p className="mx-auto mt-2 max-w-md leading-relaxed text-ink-600">{t('devisWizard.booking.bookedDesc')}</p>
      </motion.div>
    )
  }

  return (
    <div className="space-y-6">
      {/* teaser */}
      <div className="relative overflow-hidden rounded-2xl border border-accent-200 bg-gradient-to-br from-accent-50 via-white to-accent-50/60 p-5 sm:p-6">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-accent-600 to-accent-700 text-white shadow-[0_10px_24px_-10px_rgba(59,93,255,0.7)]">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" aria-hidden>
              <rect x="5" y="11" width="14" height="9" rx="2" />
              <path d="M8 11V8a4 4 0 0 1 8 0v3" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-semibold text-ink-950">{t('devisWizard.booking.teaserTitle')}</p>
            <p className="mt-1 text-xs leading-relaxed text-ink-600">{t('devisWizard.booking.teaserDesc')}</p>
          </div>
        </div>
      </div>

      <CalEmbed
        namespace="devis"
        active={active}
        name={answers.name}
        email={answers.email}
        onBooked={onBooked}
        loadingLabel={t('contactPage.callLoading')}
        fallbackLabel={t('devisWizard.booking.calFallback')}
      />
    </div>
  )
}
